<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <create-course-plan v-if="active && allowedRoles" :section="section" @reload="reload"></create-course-plan>

      <v-card v-else>
        <v-card-title>
          
          <v-spacer></v-spacer>
          <clone-form-dialog :sectionItems="sectionItems" :sectionSelected="section" @reload='reload' v-if="allowedRoles"></clone-form-dialog>
          <!-- <v-btn dark color="pink" @click="regenerateCoursePlans"><v-icon left>autorenew</v-icon> สร้างแผนการสอนใหม่</v-btn>
          <v-btn dark color="blue" @click="recalcurateWages"><v-icon left>autorenew</v-icon> คำนวณค่าตอบแทน</v-btn> -->
          <v-dialog
              v-model="processDialog"
              persistent
              width="300"
            >
              <v-card
                color="primary"
                dark
              >
                <v-card-text>
                  {{ processTitle }}
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          <timesheet-exporter :sectionSelected="section" :subject="subject"></timesheet-exporter>
        </v-card-title>

      <v-data-table
          :loading="loading"
          v-bind:headers="headers"
          :items="coursePlanItems"
          :total-items="totalItems"
          :pagination.sync="pagination"
          hide-actions
          class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.week }}</td>
          <td class="text-xs-center">{{ props.item.date | formatShortDate }}</td>
          <td class="text-xs-left">{{ props.item.lectureTitle }}</td>
          <td class="text-xs-center">{{ props.item.lectureHours }}</td>
          <td class="text-xs-center">{{ props.item.lecturers }}</td>
          <td class="text-xs-left">{{ props.item.groupTitle }}</td>
          <td class="text-xs-center">{{ props.item.groupHours }}</td>
          <td class="text-xs-center">
            <v-icon color="green" v-if="props.item.completed">done</v-icon>
            <v-icon color="grey" v-else>remove</v-icon>
          </td>
          <td class="text-xs-right">
            <v-layout row v-if="allowedRoles">
            <v-tooltip left>
              <v-btn icon slot="activator" class="blue--text" @click.native.stop="onView(props.item)" :loading="loading" :disabled="loading">           
                <v-icon v-if="props.item.timesheets.length > 0">pageview</v-icon>
                <v-icon v-else>edit</v-icon>
              </v-btn>
              <span>ดูข้อมูลสัปดาห์ที่ {{props.item.week}}</span>
            </v-tooltip>

            <!-- <template v-if="props.item.date != null && props.item.lectureTitle != null && props.item.groupTitle != null && props.item.lectureInstructors.length > 0"> -->
            <template v-if="props.item.date != null && props.item.lectureTitle != null && props.item.groupTitle != null">

              <template v-if="props.item.timesheets.length === 0">
                <v-tooltip left>
                  <v-btn icon slot="activator" class="green--text" @click.native.stop="onCreateTimesheet(props.item)" :loading="loading" :disabled="loading">
                    <v-icon>add_circle_outline</v-icon>
                  </v-btn>
                  <span>สร้างเวลาปฏิบัติงานสัปดาห์ที่ {{props.item.week}}</span>
                </v-tooltip>
              </template>
              <template v-else>
                <v-tooltip left>
                  <v-btn icon slot="activator" class="orange--text" @click.native.stop="onViewTimesheet(props.item)" :loading="loading" :disabled="loading">
                    <v-icon v-if="props.item.completed">pageview</v-icon>
                    <v-icon v-else>edit</v-icon>
                  </v-btn>
                  <span>ลงเวลาปฏิบัติงานสัปดาห์ที่ {{props.item.week}}</span>
                </v-tooltip>
                 <v-tooltip left v-if="props.item.completed">
                  <v-btn icon slot="activator" class="deep-purple--text" @click.native.stop="onViewWage(props.item)" :loading="loading" :disabled="loading">
                    <v-icon>receipt</v-icon>
                  </v-btn>
                  <span>ดูอัตราค่าตอบแทน</span>
                </v-tooltip>
              </template>
            </template>

            <v-tooltip left v-if="allowedRoles">
              <v-btn icon slot="activator" class="pink--text" @click.native.stop="resetCoursePlan(props.item)" :disabled="loading">
                <v-icon>autorenew</v-icon>
              </v-btn>
              <span>reset</span>
            </v-tooltip>

            </v-layout>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination :length="Math.ceil(totalItems / pagination.rowsPerPage)" v-model="pagination.page" :total-visible="7"></v-pagination>
      </div>
      <component :is="formDialog" :dialog="dialog" :title="title" :item="selectedItem" @dialog="dialog = $event"></component>

      <component v-bind:is="timesheetComponent" :dialog="timesheetDialog" :sectionId="sectionId" :subject="subject" :item="selectedItem" :title="title" @dialog="timesheetDialog = $event"></component>

      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import swal from 'sweetalert2'
import LGFormDialog from '../forms/lgFormDialog.vue'
import CloneFormDialog from '../forms/cloneFormDialog.vue'
import CreateCoursePlan from '../filters/createCoursePlan.vue'
import TimesheetExporter from '../filters/timesheetExporter.vue'
import TimesheetFormDialog from '../forms/timesheetLGFormDialog.vue'
import WageInfoDialog from '../forms/wageInfoDialog.vue'

export default {
  props: ['section', 'sectionItems', 'subject', 'allowedRoles'],
  components: {
    LGFormDialog,
    CloneFormDialog,
    CreateCoursePlan,
    TimesheetExporter,
    TimesheetFormDialog,
    WageInfoDialog
  },
  data () {
    return {
      active: false,
      loading: false,
      // pagination: { rowsPerPage: 15,  totalItems: 15 },
      headers: [
        { text: 'สัปดาห์', align: 'center', sortable: false, value: 'week', width: '100' },
        { text: 'วันที่', align: 'center', sortable: false, value: 'date', width: '100' },
        { text: 'หัวข้อบรรยาย(L)', align: 'left', sortable: false, value: 'lectureTitle' },
        { text: 'ชั่วโมง(L)', align: 'center', sortable: false, value: 'lectureHours' },
        { text: 'วิทยากร', align: 'center', sortable: false, value: 'lecturers'},
        { text: 'หัวข้อกิจกรรม(G)', align: 'left', sortable: false, value: 'groupTitle' },
        { text: 'ชั่วโมง(G)', align: 'center', sortable: false, value: 'groupHours' },
        { text: 'status', align: 'center', sortable: false, value: 'completed', width: '100' },
        { sortable: false}
      ],
      formDialog: null,
      dialog: false,
      title: {
        subject: this.subject,
        timesheet: null,
        week: null
      },
      timesheetComponent: null,
      timesheetDialog: false,
      sectionId: null,
      selectedItem: {},
      coursePlanItems: [],
      processDialog: false,
      processTitle: '',
      totalItems: 0,
      pagination: {
        q: '',
        descending: false,
        page: 1,
        rowsPerPage: 5, // -1 for All
        sortBy: 'week'
      }
    }
  },
  mounted () {
    // console.log("dataTableLG mounted")
    this.reload ()
  },
  computed: {

  },
  methods: {
    onView (item) {
      this.loading = true
      // console.log('onView', item)
      this.formDialog = 'l-g-form-dialog'
      this.title.week = item.week
      this.selectedItem = {...item}
      setTimeout(()=>{
        this.dialog = true
        this.loading = false
      }, 200)
    },
    onCreateTimesheet (item) {
      this.loading = true
      // console.log('onCreateTimesheet', item)
      this.$store.dispatch("timesheet/createTimesheet", item.id)
        .then((response) => {
          // console.log("response", response.data)
          this.reload().then(()=>{
            const x = this.coursePlanItems.filter(c => c.id == item.id)
            // console.log("x", x[0])
            this.onViewTimesheet(x[0])
            this.loading = false
          })
        }).catch((error)=>{
          console.log('onCreateTimesheet error', error)
          this.loading = false
        })
    },
    onViewTimesheet (item) {
      // console.log('onViewTimesheet', item)
      this.timesheetComponent = 'timesheet-form-dialog'
      item.timesheets.sort((a, b) => {
        let x = a.subSectionName.toLowerCase();
        let y = b.subSectionName.toLowerCase();
        if (x < y) {return -1;}
        if (x > y) {return 1;}
        return 0;
      })
      this.selectedItem = {...item}
      this.sectionId = item.section.id
      this.title.timesheet = `ลงเวลาปฏิบัติงาน สัปดาห์ที่ ${item.week} วันที่ ${this.$options.filters.formatShortDate(item.date)}`
      setTimeout(()=>{this.timesheetDialog = true}, 100)
    },
    onViewWage (item) {
      // console.log('onViewWage', item)
      this.timesheetComponent = 'wage-info-dialog'
      item.timesheets.sort((a, b) => {
        let x = a.subSectionName.toLowerCase();
        let y = b.subSectionName.toLowerCase();
        if (x < y) {return -1;}
        if (x > y) {return 1;}
        return 0;
      })
      this.selectedItem = {...item}
      this.sectionId = item.section.id
      this.title.timesheet = `อัตราค่าตอบแทน สัปดาห์ที่ ${item.week} วันที่ ${this.$options.filters.formatShortDate(item.date)}`
      setTimeout(()=>{this.timesheetDialog = true}, 100)
    },
    reload () {
      this.loading = true
      this.pagination.section = this.section
      return this.$store.dispatch("coursePlan/loadItemsBySectionAsPage", this.pagination)
        .then((response) => {
          this.loading = false
          this.totalItems = response.data.totalItems
          this.coursePlanItems = response.data.items
          this.coursePlanItems.length > 0 ? this.active = false : this.active = true
        }).catch((error)=>{
          console.log('reload err', error)
          this.loading = false
        })
    },
    recalcurateWages () {
      this.processTitle = 'กำลังคำนวณค่าตอบแทน...'
      const vm = this
      swal({
        title: 'ยืนยันการค่าตอบแทนใหม่',
        text: "คุณแน่ใจว่าต้องการค่าตอบแทนใหม่?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) =>  {
        vm.processDialog = true
        if (result.value) {
          return this.$store.dispatch("wage/recalculateWages", this.section)
            .then((response) => {
              console.log("response", response)
              this.processDialog = false
            }).catch((error)=>{
              console.log('reload err', error)
              this.processDialog = false
            })
        } else {
          vm.processDialog = false
        }
      })
    },
    regenerateCoursePlans () {
      this.processTitle = 'กำลังสร้างแผนการสอนใหม่ทั้งหมด...'
      const vm = this
      swal({
        title: 'ยืนยันการสร้างแผนการสอนใหม่ทั้งหมด',
        text: "คุณแน่ใจว่าต้องการสร้างแผนการสอนใหม่ทั้งหมด?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) =>  {
        vm.processDialog = true
        if (result.value) {
          return vm.$store.dispatch("coursePlan/regenerateCoursePlans", vm.section)
            .then((response) => {
              // console.log("response", response)
              vm.processDialog = false
              vm.reload ()
            }).catch((error)=>{
              console.log('reload err', error)
              vm.processDialog = false
            })
        } else {
          vm.processDialog = false
        }
      })
    },
    resetCoursePlan (item) {
      this.processTitle = 'กำลังสร้างแผนการสอนใหม่...'
      const vm = this
      swal({
        title: 'ยืนยันการสร้างแผนการสอนใหม่',
        text: "คุณแน่ใจว่าต้องการสร้างแผนการสอนใหม่?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) =>  {
        vm.processDialog = true
        if (result.value) {
          return vm.$store.dispatch("coursePlan/resetCoursePlan", item.id)
            .then((response) => {
              // console.log("response", response)
              vm.processDialog = false
              vm.reload ()
            }).catch((error)=>{
              console.log('reload err', error)
              vm.processDialog = false
            })
        } else {
          vm.processDialog = false
        }
      })
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    },
    section (val) {
      if(val) this.reload ()
    },
    dialog: function(val) {
      // console.log('dialog: ' + val)   
      if(!val) {
        this.reload ()
      }
    },
    timesheetDialog: function(val) {
      // console.log('timesheetDialog: ' + val)   
      if(!val) {
        this.reload ()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/course/coursePlan/dataTables/dataTableLG.vue